import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  content: {
    flexGrow: 1,
  },
  amount: {
    flexShrink: 0,
  },
}));

export default useStyles;
